export const getCartToken = () => {
    return localStorage.getItem('cart_token');
};

export const setCartToken = (token) => {
    localStorage.setItem('cart_token', token);
};

export const removeCartToken = () => {
    localStorage.removeItem('cart_token');
};
